// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"caf5e9ab812bc08e12da","691":"0d248da327b2aa4fd299","731":"4de9ce362d77a543c4d1","843":"4585edd1340a400ccded"}[chunkId] + ".js";
};